export default "__VITE_ASSET__Dzi2jtmA__"